import produce from 'immer';

import {
  LCFS_FETCH_FAILURE,
  LCFS_FETCH_SUCCESS,
  LOCATION_CUSTOM_FIELD_CREATE_FAILURE,
  LOCATION_CUSTOM_FIELD_CREATE_SUCCESS,
  LOCATION_CUSTOM_FIELD_EDIT_FAILURE,
  LOCATION_CUSTOM_FIELD_EDIT_SUCCESS,
  LOCATION_CUSTOM_FIELD_FETCH_FAILURE,
  LOCATION_CUSTOM_FIELD_FETCH_SUCCESS,
  LOCATION_CUSTOM_FIELDS_FETCH_FAILURE,
  LOCATION_CUSTOM_FIELDS_FETCH_SUCCESS,
  LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE,
  LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS,
} from '@actions/locationCustomField';

const initialState: ILocationCustomFieldStore = {
  locationCustomFields: null,
  currentLocationCustomField: null,
  lcfs: null,
  error: null,
  isFetching: null,
};

export default (state: ILocationCustomFieldStore = initialState, action: any) =>
  produce(state, (draftState: ILocationCustomFieldStore) => {
    switch (action.type) {
      case LOCATION_CUSTOM_FIELDS_FETCH_FAILURE:
        draftState.isFetching = true;
        draftState.locationCustomFields = null;
        draftState.error = action.error;

        return;

      case LOCATION_CUSTOM_FIELDS_FETCH_SUCCESS:
      case LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_SUCCESS:
        draftState.isFetching = true;
        draftState.locationCustomFields = action.response;
        draftState.error = null;

        return;

      case LOCATION_CUSTOM_FIELD_CREATE_FAILURE:
      case LOCATION_CUSTOM_FIELD_EDIT_FAILURE:
      case LOCATION_CUSTOM_FIELDS_SEQUENCE_EDIT_FAILURE:
        draftState.isFetching = true;
        draftState.error = action.error;

        return;

      case LOCATION_CUSTOM_FIELD_CREATE_SUCCESS:
      case LOCATION_CUSTOM_FIELD_EDIT_SUCCESS:
      case LOCATION_CUSTOM_FIELD_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.currentLocationCustomField = action.response;
        draftState.error = null;

        return;

      case LOCATION_CUSTOM_FIELD_FETCH_FAILURE:
        draftState.isFetching = true;
        draftState.currentLocationCustomField = null;
        draftState.error = action.error;

        return;

      case LCFS_FETCH_FAILURE:
        draftState.isFetching = true;
        draftState.lcfs = [];
        draftState.error = action.error;

        return;

      case LCFS_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.lcfs = action.response;
        draftState.error = null;

        return;
    }
  });
